import React, { lazy, Suspense } from 'react';
import { Link } from 'react-router-dom';
import {SignatureStrip} from "../components/SignatureStrip";

const SocialLinks = lazy(() => import('./SocialLinks'));

const Footer = () => {
    return (
        <footer>
            <div className={'container mt-2'}>
                <div className={'row  justify-content-lg-start justify-content-center'}>
                    <div className={'col-lg-4 col-10 text-lg-start text-center mt-lg-0 mt-3'}>
                        <Link to="/">
                            <img src={"/assets/images/logos/logo-dark.png"} className={'w-50'} alt="Garden  of Life"/>
                        </Link>
                    </div>
                    <div className={'col-lg-3 col-6 mt-4'}>
                        <ul className={'list-links'}>
                            <li className={'ff-main-title-semi primary-text'}>Company</li>
                            <li><Link to={'/'}>Home</Link></li>
                            <li><Link to={'/about'}>About</Link></li>
                            <li><Link to={'/projects'}>Projects</Link></li>
                            <li><Link to={'/metaverse'}>Metaverse</Link></li>
                            <li><Link to={'/shop'}>Shop</Link></li>
                        </ul>
                    </div>

                    <div className={'col-lg-3 col-6 mt-4'}>
                        <ul className={'list-links'}>
                            <li className={'ff-main-title-semi primary-text'}>Documentation</li>
                            <li><Link to={'/charity'}>Charity</Link></li>
                            <li><Link to={'/partners'}>Partners</Link></li>
                            <li><Link to={'/faqs'}>FAQS</Link></li>
                            <li><Link to={'/blogs'}>Blog</Link></li>
                        </ul>
                    </div>

                    <div className={'col-lg-2 col-6 mt-4 '}>
                        <div className={'ff-main-title-semi primary-text fs-13'}>Connect</div>
                        <Suspense fallback={<></>}>
                            <SocialLinks className={'social-links mt-1'}/>
                        </Suspense>
                        <div
                            className={'d-lg-block d-none ff-main-text-regular fs-13 text-underlined secondary-text mt-lg-3 mt-0'}>
                            <Link to={'/contact'}>Contact Us</Link>
                        </div>
                    </div>
                    <div className={'col-6 d-lg-none d-block  mt-4'}>
                        <div className={'ff-main-text-regular fs-13 text-underlined secondary-text'}><Link
                            to={'/contact'}>Contact Us </Link></div>
                    </div>
                </div>
                <div className={'row justify-content-between ff-main-text-regular fs-12  mt-5 pt-3 secondary-text'}>
                    <div className={'col-lg-6 col-md-12 text-lg-start text-center mb-lg-0 mb-2'}>
                        <p>© Garden of Life all rights reserved 2024 </p>
                    </div>
                    <div className={'col-lg-6 col-md-12 text-lg-end text-center'}>
                        <div className={'mb-lg-0 mb-3'}>
                            <Link className={'me-2'} to={'/terms-and-conditions'}>Terms & Conditions </Link> | <Link
                            className={'ms-2'} to={'/privacy-policy'}> Privacy policy</Link>
                        </div>
                    </div>
                </div>
            </div>

            <div className={'container-fluid'}>
                <div
                    className={'row'}>
                    <div className={'col-12 p-0'}>
                        <SignatureStrip/>
                    </div>
                </div>
            </div>

        </footer>
    );
};

export default Footer;
